import contact from '../../assets/images/contact/contact.svg';

const headingSection = {
    title: "Contact Us",
    breadcrumb: [
        { name: "Home", className: "breadcrumb-item", link: "/" },
        { name: "Page", className: "breadcrumb-item", link: "#" },
        { name: "Contact Us", className: "breadcrumb-item active" }
    ]
}

const contactData = [
    {
        title: 'Phone',
        discription: 'Start working with Subul Contracting that can provide everything',
        data: '+966 55 977 6684',
        textBold: false,
        sameClassName: false,
        icon: 'uil-phone',
    },
    {
        title: 'Email',
        discription: 'Start working with Subul Contracting that can provide everything',
        data: 'Info@subul-contracting.sa',
        textBold: false,
        sameClassName: true,
        icon: 'uil-envelope',
    },
    {
        title: 'Location',
        discription: 'Prince Muhammad Ibn Saad Ibn Abdulaziz Rd, Al Aqiq, Riyadh 13511, Saudi Arabia',
        data: 'View on Google map',
        textBold: true,
        sameClassName: true,
        icon: 'uil-map-marker',
    },
]

const formSection = {
    title: "Get In Touch !",
    img: contact,
    formFields: [
        {
            name: 'name',
            label: 'Your Name',
            type: 'text',
            icon: 'user',
            placeholder: 'Your Name :',
        },
        {
            name: 'email',
            label: 'Your Email',
            type: 'email',
            icon: 'mail',
            placeholder: 'Your email :',
        },
        {
            name: 'mobile',
            label: 'Mobile',
            type: 'text',
            icon: 'phone',
            placeholder: '+966 Your mobile :',
        },
        {
            name: 'subject',
            label: 'Subject',
            type: 'text',
            icon: 'book',
            placeholder: 'Your subject :',
        },
        {
            name: 'comments',
            label: 'Comments',
            type: 'textarea',
            icon: 'message-circle',
            placeholder: 'Your Message :',
        },
    ],
    btnText: "Send Message"
}

// change with only map direct url, you can get from google map
const mapLocation = 'https://www.google.com/maps/place/24%C2%B046\'01.3%22N+46%C2%B037\'23.7%22E/@24.7670278,46.62325,17z/data=!3m1!4b1!4m4!3m3!8m2!3d24.7670278!4d46.62325?entry=ttu&g_ep=EgoyMDI1MDgxOC4wIKXMDSoASAFQAw%3D%3D';

// change with only embed iframe url, you can get from google map
const mapUrl = "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3622.8300974646454!2d46.62067847536786!3d24.767013877990426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQ2JzAxLjMiTiA0NsKwMzcnMjMuNyJF!5e0!3m2!1sen!2sin!4v1755779303263!5m2!1sen!2sin"

export { headingSection, contactData, formSection, mapLocation, mapUrl }